<template>
    <div class="mobile-breadcrumbs">
        <a @click="navigate">{{ label }}</a>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        to: {
            type: [String, Object],
            default: null,
        },
    },
    methods: {
        navigate() {
            if (this.to) {
                this.$router.push(this.to);
            } else {
                let to = {
                    name: this.$route.name,
                    params: { ...this.$route.params },
                    query: { ...this.$route.query },
                };
                delete to.query.mView;
                this.$router.push(to);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../styles/rem';
    @import '../../styles/mrem';

    .mobile-breadcrumbs {
        display: flex;
        align-items: center;
        margin: rem(24) 0;
        cursor: pointer;

        @include on-mobile {
            margin: mrem(24) mrem(16);
        }

        a {
            font-family: "Montserrat", sans-serif;
            font-style: normal;
            font-weight: 600;
            color: #BAC5CB;
            font-size: rem(16);
            line-height: rem(20);

            @include on-mobile {
                font-size: mrem(12);
                line-height: mrem(15);
            }
        }

        &::before {
            content: ' ';
            width: rem(8);
            height: rem(13);
            margin-right: rem(8);
            display: block;
            background: no-repeat center/contain
                url(../../assets/images/UI/chevron-left-grey.svg);

            @include on-mobile {
                width: mrem(13);
                height: mrem(13);
                margin-right: mrem(8);
            }
        }
    }
</style>
